import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const SendIcon = (props) => {
    const {fill = 'var(--primary)'}= props;
  return (
    <SvgIcon {...props} viewBox="0 0 26.16 22.423">
      <path id="ic_send_24px" d="M2.012,25.423,28.16,14.211,2.012,3,2,11.72l18.686,2.491L2,16.7Z"
            transform="translate(-2 -3)" fill={fill}/>
    </SvgIcon>
  );
};

SendIcon.propTypes = {}

SendIcon.defaultProps = {}

export default SendIcon;